import { render, staticRenderFns } from "./GroupChannelSelect.vue?vue&type=template&id=739c2902&"
import script from "./GroupChannelSelect.vue?vue&type=script&lang=js&"
export * from "./GroupChannelSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports